// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_49-0";
export var eligibilityCardNotEligible = "_49-1";